import axios from 'axios' // 引入
import JsonBig from 'json-bigint'

let baseURL = '/apis'
// 判断出当前是开发环境还是生产环境
// if(process.env.NODE_ENV==''development''){
//   baseURL=''
// }else{
//   baseURL=''
// }

let config = {
  baseURL: baseURL,
  timeout: 30000 // 设置最大请求时间
}
const _axios = axios.create(config)
/* 请求拦截器 */
_axios.interceptors.request.use(
  config => {
    if (config.url !== '/locationbs/login') {
      config.headers.Authorization = sessionStorage.getItem('token')
    }
    return config
  },
  err => Promise.reject(err)
)
/* 响应拦截器 */
_axios.interceptors.response.use(
  res => {
    // 保存登录token
    if (res.headers.authorization) {
      console.log(res.headers.authorization)
      sessionStorage.setItem('token', res.headers.authorization)
    }
    if (res.data.code === 401) {
      // sessionStorage.clear()
      // this.$router.push('/')
    }
    if (res.data.code === 400) {
      console.log('请求网络失败')
    }
    if (res.data.code === 404) {
      console.log('请求网络失败')
    }
    return res
  },
  err => {
    if (err) {
      // 在这里关闭请求时的loading动画效果
      console.log('请求网络失败')
    }
    return Promise.reject(err)
  }
)
// 处理文件流类型以及long超过16位丢失精度
_axios.defaults.transformResponse = [
  function (data, headers) {
    if (headers['content-type'] === 'application/octet-stream') {
      return data
    } else {
      try {
        const jsonbig = JsonBig({
          storeAsString: true
        })
        return jsonbig.parse(data)
      } catch (err) {
        return data
      }
    }
  }
]
// 封装post,get方法
const http = {
  get (url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        params,
        method: 'GET'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  },
  post (url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data: params,
        method: 'POST'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  },
  put (url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data: params,
        method: 'PUT'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  },
  delete (url = '', id = '') {
    return new Promise((resolve, reject) => {
      _axios({
        url: url + id,
        method: 'DELETE'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default http



// WEBPACK FOOTER //
// ./src/javascript/http.js